module.exports = __webpack_public_path__ + "img/olt_4kl.8eb66c61.jpg";